<template>
  <div class="quality-table">
    <table border="1">
      <tr>
        <th>工序</th>
        <th>部件</th>
        <th>详细描述</th>
        <th>维修</th>
        <th>签名/日期</th>
      </tr>

      <!-- 三大件 -->
      <tr>
        <td rowspan="5">三大件</td>
        <td rowspan="2">主机</td>
        <td>
          冠泽主机，出现 WiFi 断连、花屏、黑屏、乱码、卡死等现象，更换新主机。
        </td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.host"
            :disabled="props.disabled"
          >
            <a-radio :value="true">更换故障主机</a-radio>
            <a-radio :value="false">不更换主机</a-radio>
          </a-radio-group>
        </td>
        <td rowspan="5">
          <a-input
            placeholder="签名"
            v-model:value="repairData.threeMajorItemsSign"
          ></a-input>
          <a-date-picker
            placeholder="请选择日期"
            v-model:value="repairData.threeMajorItemsDate"
            @change="handleSelectTime($event, 'threeMajorItemsDate')"
          />
        </td>
      </tr>

      <tr>
        <td>
          GZ750LW230206001~GZ750LW230206010 GZ750LW230306001~GZ750LW230306030
          GZ750LW230209001~GZ750LW230209010 GZ750LW230207001~GZ750LW230207033
        </td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.gzHost"
            :disabled="props.disabled"
          >
            <a-radio :value="true">更换潜在风险主机</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td>网线</td>
        <td>
          新主机：USB连接到相机（黑色网线），主机连接到采集卡（蓝色网线）。
          冠泽主机：USB连接到采集卡（蓝色网线），主机连接到相机（黑色网线）。
        </td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.networkCable"
            :disabled="props.disabled"
          >
            <a-radio value="新主机更换网线">新主机更换网线</a-radio>
            <a-radio value="冠泽主机更换网线">冠泽主机更换网线</a-radio>
            <a-radio value="不更换网线">不更换网线</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td>线束</td>
        <td>按照最新的作业指导书进行走线整改。</td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.threeMajorItemsPencil"
            :disabled="props.disabled"
          >
            <a-radio :value="true">整改线束</a-radio>
            <a-radio :value="false">不整改线束</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td>其他</td>
        <td>
          <a-textarea
            autoSize
            v-model:value="repairData.threeMajorItemsDesc"
          ></a-textarea>
        </td>
        <td>
          <a-textarea
            autoSize
            v-model:value="repairData.threeMajorItemsRepair"
          ></a-textarea>
        </td>
      </tr>

      <!-- 参考臂 -->
      <tr>
        <td rowspan="4">参考臂</td>
        <td>出光光功率</td>
        <td>
          <a-space direction="vertical">
            <a-space>
              <div>参考臂制作日期：</div>
              <a-date-picker
                v-model:value="repairData.referenceArmMakeDate"
                @change="handleSelectTime($event, 'referenceArmMakeDate')"
              />
            </a-space>

            <a-space>
              <div>参考臂复测日期：</div>
              <a-date-picker
                v-model:value="repairData.referenceArmRetestDate"
                @change="handleSelectTime($event, 'referenceArmRetestDate')"
              />
            </a-space>

            <a-space>
              <div>实测25尾(mw)：</div>
              <a-input-number
                :step="0.01"
                v-model:value="repairData.measured25Tail"
              ></a-input-number>
            </a-space>
            <a-space>
              <div>理论25中(uw)：</div>
              <a-input-number
                :step="0.01"
                v-model:value="repairData.theory25Mid"
              ></a-input-number>
            </a-space>
            <a-space>
              <div>实测25中(uw)：</div>
              <a-input-number
                :step="0.01"
                v-model:value="repairData.measured25Mid"
              ></a-input-number>
            </a-space>
          </a-space>
        </td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.isReferenceArmQualified"
            :disabled="props.disabled"
          >
            <a-radio :value="true">实测25中≥理论25中，参考臂合格</a-radio>
            <a-radio :value="false">实测25中＜理论25中，更换参考臂</a-radio>
          </a-radio-group>
        </td>
        <td rowspan="4">
          <a-input
            placeholder="签名"
            v-model:value="repairData.referenceArmSign"
          ></a-input>
          <a-date-picker
            placeholder="请选择日期"
            v-model:value="repairData.referenceArmDate"
            @change="handleSelectTime($event, 'referenceArmDate')"
          />
        </td>
      </tr>

      <tr>
        <td>600束腰</td>
        <td>不满足600信号标准的，重新调试【束腰】和水平。</td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.girdling"
            :disabled="props.disabled"
          >
            <a-radio :value="true">调试束腰</a-radio>
            <a-radio :value="false">不调试束腰</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td>光纤</td>
        <td>按照最新作业指导书重新整理光纤。</td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.opticalFiber"
            :disabled="props.disabled"
          >
            <a-radio :value="true">整理光纤</a-radio>
            <a-radio :value="false">不需要整理</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td>其他</td>
        <td>
          <a-textarea
            autoSize
            v-model:value="repairData.referenceArmDesc"
          ></a-textarea>
        </td>
        <td>
          <a-textarea
            autoSize
            v-model:value="repairData.referenceArmRepair"
          ></a-textarea>
        </td>
      </tr>

      <!-- 完整参考臂 -->
      <tr>
        <td rowspan="11">完整参考臂</td>
        <td rowspan="3">探测器</td>
        <td>
          探测器SN号介于221032386~221032485和221032187~221032286区间，更换合格探测器。
        </td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.detector"
            :disabled="props.disabled"
          >
            <a-radio value="更换新探测器">更换新探测器</a-radio>
          </a-radio-group>
        </td>
        <td rowspan="11">
          <a-input
            placeholder="签名"
            v-model:value="repairData.completeReferenceArmSign"
          ></a-input>
          <a-date-picker
            placeholder="请选择日期"
            v-model:value="repairData.completeReferenceArmDate"
            @change="handleSelectTime($event, 'completeReferenceArmDate')"
          />
        </td>
      </tr>

      <tr>
        <td>
          探测器SN号介于
          221031982-221032031区间，检测接地性能，若不合格，更换合格探测器。
        </td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.detector"
            :disabled="props.disabled"
          >
            <a-radio value="合格，不需要更换探测器"
              >合格，不需要更换探测器</a-radio
            >
            <a-radio value="不合格，更换新探测器">不合格，更换新探测器</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td>探测器不属于以上区间，则不需要更换。</td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.detector"
            :disabled="props.disabled"
          >
            <a-radio value="不需要更换探测器">不需要更换探测器</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td rowspan="3">屏幕</td>
        <td>
          屏幕一代二代，如果出现故障，需要更换屏幕+驱动板+电源控制板+线束。
        </td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.screen"
            :disabled="props.disabled"
          >
            <a-radio value="更换新屏幕集成">更换新屏幕集成</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td>
          屏幕一代二代，如果出现故障，需要更换屏幕+驱动板+电源控制板+线束。
        </td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.screen"
            :disabled="props.disabled"
          >
            <a-radio value="不需要更换屏幕">不需要更换屏幕</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td>屏幕三代，需要确认驱动板是3.1版本；白色排线换为金色排线。</td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.screen"
            :disabled="props.disabled"
          >
            <a-radio value="确定是3.1版本">确定是3.1版本</a-radio>
            <a-radio value="升级为3.1版本">升级为3.1版本</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td>SMA线</td>
        <td>粗SMA 线更换为最新细SMA线</td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.smaCable"
            :disabled="props.disabled"
          >
            <a-radio :value="true">更换SMA线</a-radio>
            <a-radio :value="false">不更换SMA线</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td>网线</td>
        <td>
          细网线更换为最新的粗网线；
          新主机：USB连接到相机（黑色网线），主机连接到采集卡（蓝色网线）。
          冠泽主机：USB连接到采集卡（蓝色网线），主机连接到相机（黑色网线）。
        </td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.completeReferenceArmNet"
            :disabled="props.disabled"
          >
            <a-radio value="新主机更换网线">新主机更换网线</a-radio>
            <a-radio value="冠泽主机更换网线">冠泽主机更换网线</a-radio>
            <a-radio value="不更换网线">不更换网线</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td>线束</td>
        <td>按照最新的作业指导书进行走线整改。</td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.completeReferenceArmPencil"
            :disabled="props.disabled"
          >
            <a-radio :value="true">整改线束</a-radio>
            <a-radio :value="false">不整改线束</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td>调试水平</td>
        <td>不满足600信号标准的，重新调试束腰和【水平】。</td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.debugLevel"
            :disabled="props.disabled"
          >
            <a-radio :value="true">调试水平</a-radio>
            <a-radio :value="false">不调试水平</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td>其他</td>
        <td>
          <a-textarea
            autoSize
            v-model:value="repairData.completeReferenceArmDesc"
          ></a-textarea>
        </td>
        <td>
          <a-textarea
            autoSize
            v-model:value="repairData.completeReferenceArmRepair"
          ></a-textarea>
        </td>
      </tr>
      <!-- 定标 -->
      <tr>
        <td rowspan="3">定标</td>

        <td>600定标</td>
        <td>
          软件升级到最新程序，开发者模式打开降采样开关，若开机报【仪器未定标】，则须用降采样定标软件计算设备的原始定标数据，再将降采样定标结果拷贝至swan文件夹。
        </td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.instrumentCalibrate"
            :disabled="props.disabled"
          >
            <a-radio :value="true"
              >开机没有【仪器未定标】，不需要任何设置</a-radio
            >
            <a-radio :value="false"
              >开机有【仪器未定标】，降采样定标结果拷贝至swan文件夹</a-radio
            >
          </a-radio-group>
        </td>
        <td rowspan="3">
          <a-input
            placeholder="签名"
            v-model:value="repairData.calibrateSign"
          ></a-input>
          <a-date-picker
            placeholder="请选择日期"
            v-model:value="repairData.calibrateDate"
            @change="handleSelectTime($event, 'calibrateDate')"
          />
        </td>
      </tr>

      <tr>
        <td>调试偏振</td>
        <td>定标品检验之前，调试偏振到最好状态。</td>
        <td>
          <a-radio-group
            name="radioGroup"
            v-model:value="repairData.polarization"
            :disabled="props.disabled"
          >
            <a-radio :value="true">调试偏振</a-radio>
            <a-radio :value="false">不调试偏振</a-radio>
          </a-radio-group>
        </td>
      </tr>

      <tr>
        <td>其他</td>
        <td>
          <a-textarea
            autoSize
            v-model:value="repairData.calibrateDesc"
          ></a-textarea>
        </td>
        <td>
          <a-textarea
            autoSize
            v-model:value="repairData.calibrateRepair"
          ></a-textarea>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { computed, defineComponent, reactive, watch } from "vue";

export default defineComponent({
  props: {
    disabled: Boolean,
    echoObj: Object,
  },
  setup(props) {
    const repairData = reactive({
      // 主机维修
      host: null,
      // 网线维修
      networkCable: null,
      // 其他描述
      threeMajorItemsDesc: null,
      // 其他维修
      threeMajorItemsRepair: null,
      threeMajorItemsSign: null,
      threeMajorItemsDate: null,
      // 参考臂制作日期
      referenceArmMakeDate: null,
      // 参考复测日期
      referenceArmRetestDate: null,
      isReferenceArmQualified: null,
      // 实测25尾
      measured25Tail: null,
      // 理论25中
      theory25Mid: null,
      // 实测25中
      measured25Mid: null,
      // 参考臂维修方案
      referenceArmRepair: null,
      // 束腰维修方案
      girdling: null,
      // 光纤维修方案
      opticalFiber: null,
      // 其他描述
      referenceArmDesc: null,
      referenceArmSign: null,
      referenceArmDate: null,
      // 探测器维修
      detector: null,
      // 屏幕维修
      screen: null,
      //SMA线维修
      smaCable: null,
      // 调试水平
      debugLevel: null,
      // 其他描述
      completeReferenceArmDesc: null,
      // 其他维修
      completeReferenceArmRepair: null,
      completeReferenceArmSign: null,
      completeReferenceArmDate: null,
      // 偏振维修
      polarization: null,
      // 其他描述
      calibrateDesc: null,
      // 其他维修
      calibrateRepair: null,
      // 三大件线束
      threeMajorItemsPencil: null,
      // 完整参考臂网线
      completeReferenceArmNet: null,
      // 完整参考臂线束
      completeReferenceArmPencil: null,
      // 600定标
      instrumentCalibrate: null,
      // 更换冠泽主机
      gzHost: null,
      calibrateSign: null,
      calibrateDate: null,
    });

    const getRetificationData = () => {
      return repairData;
    };

    const handleSelectTime = (e, type) => {
      repairData[type] = e.format("YYYY-MM-DD");
    };

    watch(
      () => props.echoObj,
      (val) => {
        if (val) {
          Object.keys(repairData).forEach((key) => {
            repairData[key] = val[key];
          });
        }
        console.log(val, repairData, '++++++++++++')
      },
      {
        immediate: true,
        deep: true,
      }
    );
    return {
      handleSelectTime,
      getRetificationData,
      repairData,
      props,
    };
  },
});
</script>

<style lang="less" scoped>
.quality-table {
  font-size: 16px;
  margin-bottom: 16px;
  th {
    text-align: center;
  }
  th,
  tr {
    padding: 5px 10px;
  }
  td {
    padding: 5px;
  }
  .quality-type {
    text-align: center;
  }
  .serial-number {
    text-align: center;
  }
  .quality-title {
    width: 450px;
  }
  .describe {
    width: 320px;
  }
  ::v-deep .ant-radio-disabled .ant-radio-inner::after {
    background-color: #35b7ad !important;
  }
  ::v-deep .ant-radio-disabled + span {
    color: #000;
  }
  ::v-deep .ant-input-number-disabled {
    color: #000;
  }
}
</style>
